import { render, staticRenderFns } from "./ProductSetSelector.vue?vue&type=template&id=4b71bd2b"
import script from "./ProductSetSelector.vue?vue&type=script&lang=ts"
export * from "./ProductSetSelector.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports